// extracted by mini-css-extract-plugin
var _1 = "ekQ7P93Ao0";
export { _1 as "report" }
